import React from "react";
import ReactDOM from "react-dom";
import styled from "styled-components";

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
`;

const Box = styled.div`
  background: var(--surface, #fff);
  border-radius: 12px;
  border: 0.5px solid var(--rule, rgba(0, 0, 0, 0.1));
  width: 100%;
  max-width: ${({ $maxWidth }) => $maxWidth}px;
  max-height: 90vh;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
`;

export const Modal = ({ show, onClose, children, maxWidth = 560 }) => {
  if (!show) return null;

  return ReactDOM.createPortal(
    <Overlay onClick={e => e.target === e.currentTarget && onClose()}>
      <Box $maxWidth={maxWidth}>
        {children}
      </Box>
    </Overlay>,
    document.body
  );
};

export const ModalHeader = ({
  icon,
  title,
  subtitle,
  bg = "var(--surface-2, #fafaf9)",
  borderColor = "var(--rule, rgba(0,0,0,0.08))",
  onClose,
}) => (
  <div style={{
    padding: "18px 24px 14px",
    borderBottom: `1px solid ${borderColor}`,
    background: bg,
    flexShrink: 0,
    borderRadius: "12px 12px 0 0",
  }}>
    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
      <div>
        {title && (
          <div style={{ display: "flex", alignItems: "center", gap: 9, marginBottom: subtitle ? 5 : 0 }}>
            {icon && (
              <i
                className={icon}
                style={{ fontSize: 15, color: "#3f88a5", width: 18, textAlign: "center" }}
                aria-hidden="true"
              />
            )}
            <span style={{
              fontWeight: 700,
              fontSize: 15,
              color: "var(--ink, #111)",
              fontFamily: "var(--font-sans)",
            }}>
              {title}
            </span>
          </div>
        )}
        {subtitle && (
          <div style={{
            fontSize: 12,
            color: "var(--ink-3, #9ca3af)",
            marginLeft: icon ? 27 : 0,
            lineHeight: 1.5,
          }}>
            {subtitle}
          </div>
        )}
      </div>
      {onClose && (
        <button
          onClick={onClose}
          style={{
            border: "none",
            background: "transparent",
            cursor: "pointer",
            color: "var(--ink-3, #9ca3af)",
            padding: "0 0 0 0px",
            flexShrink: 0,
            lineHeight: 1,
            fontSize: 13,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: 28,
            height: 28,
            borderRadius: 6,
            transition: "background 0.12s",
          }}
          aria-label="Close modal"
          onMouseEnter={e => e.currentTarget.style.background = "rgba(0,0,0,0.06)"}
          onMouseLeave={e => e.currentTarget.style.background = "transparent"}
        >
          <i className="fas fa-times" aria-hidden="true" />
        </button>
      )}
    </div>
  </div>
);